<div *ngIf="isEnabled" class="ai-disclaimer-banner" role="note" aria-label="AI disclaimer">
  <i class="fa-solid fa-wand-magic-sparkles ai-disclaimer-banner__icon" aria-hidden="true"></i>
  <span class="ai-disclaimer-banner__text">This product incorporates artificial intelligence technologies and may contain errors, inconsistencies, or outdated or incomplete information. Customer shall independently verify the output or results generated.</span>
</div>
